import React from 'react'
import { encodeToUrlParams, getContentfulImageURL } from '../../../../lib/helpers';
import CategoryTag from '../../General/CategoryTag';
import { Link } from 'gatsby';

const AboutSeasonTwoSection = ({data}) => {
    return (
        <div className='about-intro'> 
            <div className="intro-grid">
                <div>
                    <div className="title-section">
                        <Link to={`/articles/?${encodeToUrlParams(['Season 2'], 'tags')}`}>
                            <CategoryTag>Season 2</CategoryTag>
                        </Link>
                        <h3>{data?.v2AboutSeason2Heading}</h3>
                    </div>
                    <p>
                        {data.v2AboutSeason2?.v2AboutSeason2}
                    </p>

                    <div className="about-intro-img-1">
                        <img src={getContentfulImageURL(data.v2AboutImages[7].file.url, 800, 85)} alt="" />
                    </div>

                </div>

                <div>
                    <div className="about-intro-img-2">
                        <img src={getContentfulImageURL(data.v2AboutImages[8].file.url, 1400, 85)} alt="" />
                    </div>
                </div>
            </div>  

            {/* <img src={getContentfulImageURL(images[2].file.url, 1600, 85)} alt="" /> */}

                



            <style jsx>{`
                .about-intro-img-1 {
                    width: 100%;
                    padding-bottom: 110%;
                    height: 0;
                    position: relative;
                    border-radius: 15px;
                    overflow: hidden;
                    margin-top: 20px;
                }

                .about-intro-img-2 {
                    width: 100%;
                    height: 100%;
                    border-radius: 15px;
                    overflow: hidden;
                    position: relative;
                }

                .intro-grid img {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .title-section {
                    padding: 20px;
                    text-align: center;
                }

                .title-section :global(.category-tag) {
                    display: inline-block;
                    margin-bottom: 12px;
                }

                h3 {
                    font-size: 64px;
                    color: #707070;
                }

                .intro-grid {
                    padding: 30px 60px;               

                    display: grid;
                    grid-template-columns: 1fr 2fr;
                    grid-gap: 30px;
                }

                p {
                    font-size: 22px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .intro-grid {
                        padding: 0px 20px;
                        grid-template-columns: 1fr;
                    }

                    h3 {
                        font-size: 48px;
                    }
                    p {
                        font-size: 18px;
                    }
                }
            `}</style>
        </div>
    )
}

export default AboutSeasonTwoSection